/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $timeout,
  webpage,
  authenticationService,
  accountService,
  eventService,
  uiService,
  accountsService,
  organizationService,
  workflowsService,
  navigationService,
  changesService,
  ACCOUNT
) => {
  $scope.Model = {
    availableAccounts: [],
    accountsList: null,
    isArchive: false,
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');
  if ($rootScope.CurrentAccount.isAdministrator) {
    $q.all([
      organizationService.readOrganization({ id: $rootScope.CurrentOrganization.id }),
      accountsService.getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.LIST }),
      accountsService.getAvailable({ isActive: false, fields: ACCOUNT.FIELDS.LIST })
    ])
      .then((data) => {
        // Overwrite $rootScope values in case they've reverted to values within Token
        $rootScope.CurrentOrganization.idAdministrators = data[0].idAdministrators;
        $rootScope.CurrentOrganization.idManagers = data[0].idManagers;
        $rootScope.CurrentOrganization.idBrokers = data[0].idBrokers;
        $rootScope.CurrentOrganization.idMentors = data[0].idMentors;
        $rootScope.CurrentOrganization.mentees = data[0].mentees;
        $rootScope.CurrentOrganization.partnersAttributes = data[0].partnersAttributes;
        // Set Model values
        const accountsData = data[1].concat(data[2]);
        const len = accountsData.length;
        for (let i = 0; i < len; i += 1) {
          accountsData[i].isOwner = authenticationService.isOwner(accountsData[i].id);
          accountsData[i].isAdministrator =
            accountsData[i].isOwner ||
            authenticationService.isAdministrator(accountsData[i].id);
          accountsData[i].isManager =
            accountsData[i].isAdministrator &&
            $rootScope.CurrentOrganization.idManagers.indexOf(accountsData[i].id) > -1;
          accountsData[i].isBroker =
            accountsData[i].isOwner || authenticationService.isBroker(accountsData[i].id);
          accountsData[i].isMentor =
            accountsData[i].isOwner || authenticationService.isMentor(accountsData[i].id);
          if (!accountsData[i].isManager) {
            $scope.Model.availableAccounts.push(accountsData[i]);
          }
        }
      })
      .then(() => {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Users : Settings');
        $scope.Model.isReady = true;
      });
  }

  /*
   * Events available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.$on('userAdd', (e, $event) => {
    eventService.accountAdd({ event: $event });
  });

  $scope.$on('userDelete', ($event) => {
    const selectedAccounts = _.without(
      $scope.Model.accountsList.getSelected(),
      _.find($scope.Model.accountsList.getSelected(), { isOwner: true })
    );
    const otherAccounts = _.difference($scope.Model.availableAccounts, selectedAccounts);
    const currentAccount = $rootScope.CurrentAccount;
    currentAccount.isOwner = authenticationService.isOwner(currentAccount.id);
    eventService.accountDelete({
      event: $event,
      accounts: otherAccounts,
      selectedAccounts
    });
  });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.accountAdded = (account) => {
    const exists = _.some($scope.Model.accountsList.getData(), (a) => a.id === account.id);
    if (!exists && account.id !== $rootScope.CurrentAccount.id) {
      accountsService.clearCache();
      $scope.Model.accountsList.setDataAppend(account);
      uiService.toast({
        text: {
          p1: 'User',
          p2: account.getName(),
          p3: 'has been added'
        }
      });
    } else {
      uiService.toast({
        text: {
          p1: 'User with E-Mail',
          p2: account.getEmail(),
          p3: 'already exists'
        },
        warn: true
      });
    }
  };

  $scope.toggleAccount = ($event, account, type) => {
    if (type === 'administrator') {
      const index = $rootScope.CurrentOrganization.idAdministrators.indexOf(account.id);
      if (index > -1) {
        $rootScope.CurrentOrganization.idAdministrators.splice(index, 1);
      } else {
        $rootScope.CurrentOrganization.idAdministrators.push(account.id);
      }
      organizationService
        .updateOrganization({
          id: $rootScope.CurrentOrganization.id,
          idAdministrators: $rootScope.CurrentOrganization.idAdministrators
        })
        .then((result) => {
          if (result.status) {
            uiService.toast({
              text: {
                p1: 'Account',
                p2: account.getName(),
                p3: `${account.isAdministrator ? 'added to' : 'removed from'} administrators`
              }
            });
          }
        });
    } else if (type === 'broker') {
      const index = $rootScope.CurrentOrganization.idBrokers.indexOf(account.id);
      if (index > -1) {
        $rootScope.CurrentOrganization.idBrokers.splice(index, 1);
      } else {
        $rootScope.CurrentOrganization.idBrokers.push(account.id);
      }
      organizationService
        .updateOrganization({
          id: $rootScope.CurrentOrganization.id,
          idBrokers: $rootScope.CurrentOrganization.idBrokers
        })
        .then((result) => {
          if (result.status) {
            uiService.toast({
              text: {
                p1: 'Account',
                p2: account.getName(),
                p3: `${account.isBroker ? 'added to' : 'removed from'} brokers`
              }
            });
          }
        });
    } else if (type === 'mentor') {
      const index = $rootScope.CurrentOrganization.idMentors.indexOf(account.id);
      if (index > -1) {
        $rootScope.CurrentOrganization.idMentors.splice(index, 1);
      } else {
        $rootScope.CurrentOrganization.idMentors.push(account.id);
      }
      organizationService
        .updateOrganization({
          id: $rootScope.CurrentOrganization.id,
          idMentors: $rootScope.CurrentOrganization.idMentors
        })
        .then((result) => {
          if (result.status) {
            uiService.toast({
              text: {
                p1: 'Account',
                p2: account.getName(),
                p3: `${account.isMentor ? 'added to' : 'removed from'} mentors`
              }
            });
          }
        });
    } else if (type === 'active') {
      accountsService.clearCache();
      const payload = {
        id: account.id,
        isDisabled: account.isDisabled,
        idCurrentOrganization: $rootScope.CurrentOrganization.id
      };
      accountService.updateAccount(payload).then((result) => {
        if (result.status) {
          uiService.toast({
            text: {
              p1: 'Account',
              p2: account.getName(),
              p3: account.isDisabled ? 'has been disabled' : 'has been enabled'
            }
          });
        }
      });
    }
  };

  $scope.accountDeleted = (account) => {
    accountsService.clearCache();
    workflowsService.clearCache();
    $scope.Model.accountsList.removeData(account);
  };

  $scope.changePartnersAttributes = (partnersAttributes) => {
    $rootScope.CurrentOrganization.partnersAttributes = partnersAttributes;
    $scope.toggleChanges('partnersAttributes', 'idPartner');
  };

  $scope.assignMentors = ($event, mentee) => {
    const mentors = _.filter(
      $scope.Model.availableAccounts,
      (a) => $rootScope.CurrentOrganization.idMentors.indexOf(a.id) > -1
    );
    eventService.mentorAssign({ event: $event, currentMentee: mentee, accounts: mentors });
  };

  $scope.assignedMentors = (currentMentee, accounts) => {
    if (
      $rootScope.CurrentOrganization.mentees &&
      $rootScope.CurrentOrganization.mentees[currentMentee.id]
    ) {
      $rootScope.CurrentOrganization.mentees[currentMentee.id] = _.map(accounts, 'id');
    } else {
      $rootScope.CurrentOrganization.mentees = {};
      $rootScope.CurrentOrganization.mentees[currentMentee.id] = _.map(accounts, 'id');
    }
    $scope.toggleChanges('mentees');
    $scope.saveChanges();
  };

  $scope.listChange = (list, data, isSelected) => {
    $scope.$parent.Model.childStateHasSelection = isSelected || list.isSelectedAny();
  };

  $scope.listReady = (list) => {
    $scope.Model.accountsList = list;
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  const saveChanges = () => {
    const organizationData = { id: $rootScope.CurrentOrganization.id };
    if (changesService.hasChange({ group: 'partnersAttributes' })) {
      organizationData.partnersAttributes = $rootScope.CurrentOrganization.partnersAttributes;
    }
    if (changesService.hasChange({ group: 'mentees' })) {
      organizationData.mentees = $rootScope.CurrentOrganization.mentees;
    }
    return organizationService.updateOrganization(organizationData).then((result) => {
      if (result.status) {
        if (changesService.hasChange({ group: 'partnersAttributes' })) {
          navigationService.organizationChange({
            idOrganization: $rootScope.CurrentOrganization.id
          });
        }
        if (changesService.hasChange({ group: 'mentees' })) {
          navigationService.organizationChange({
            idOrganization: $rootScope.CurrentOrganization.id
          });
        }
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  };

  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);

  $scope.toggleChanges = () => {
    changesService.change();
  };

  $scope.toggleChanges = (group, field) => {
    changesService.change({ group, field });
  };
};
